import { Component, DestroyRef, inject } from '@angular/core';
import { TopMenuService } from '@client/app/layout/menu/top-menu.service';

@Component({
    selector: 'mon-app',
    template: `
        <ng-container>
            <ui-view>
                <mon-dialog-container></mon-dialog-container>
            </ui-view>
            @if (!isAdminRoute) {
                <mon-overlay-wrapper />
            }
            <unified-hotkeys-cheatsheet></unified-hotkeys-cheatsheet>
        </ng-container>
    `,
    standalone: false,
})
export class AppComponent {
    private topMenuService = inject(TopMenuService);
    private destroyRef = inject(DestroyRef);
    isAdminRoute = false;

    ngOnInit (): void {
        this.isAdminRoute = this.topMenuService.isAdminRoute;
        const subscription = this.topMenuService.isAdminRouteObs
            .subscribe((val) => {
                this.isAdminRoute = val;
            });
        this.destroyRef.onDestroy(() => {
            subscription.unsubscribe();
        });
    }
}
